import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthContext } from '@flote/app-core';
import { Header } from './Header';
import { Footer } from './Footer';
import { AuthLoadingScreen } from './AuthLoadingScreen';

function PageSkeleton() {
    return <div className="min-h-[60vh] animate-pulse bg-muted/30" />;
}

export function Layout() {
  const { isInitialized } = useAuthContext();

  if (!isInitialized) {
    return <AuthLoadingScreen />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
